import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { NotEbook } from './components/NotEbook';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PIXEL_ID } from './data/constants';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3rcj7c4kla37o">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3rbzomln47asl" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-ice font-sans text-graphite antialiased" data-id="element-2" data-mp="2zmeo498kfm81">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="33orik1hv3xpi" />}
        <main data-id="element-4" data-mp="38m1g64fenfof">
          <Hero data-id="element-5" data-mp="38l8hlqqlnwhd" />
          <PainSection data-id="element-6" data-mp="38kqafz2efxuo" />
          <SystemSection data-id="element-7" data-mp="38kgkgbhctqoz" />
          <LookInside data-id="element-8" data-mp="3dkuv81acbeqp" />
          <Bonuses data-id="element-9" data-mp="3dle30p6a0mr0" />
          <NotEbook data-id="element-10" data-mp="3dlw4c07spr5s" />
          <Offer data-id="element-11" data-mp="3dm5ylzzvikha" />
          <Guarantee data-id="element-12" data-mp="3dii3iwes5q0g" />
          <Testimonials data-id="element-13" data-mp="nvsub5qlapwh" />
          <FAQ data-id="element-14" data-mp="nuhged3fk1rn" />
          <FinalCTA data-id="element-15" data-mp="nuraabrlit2m" />
        </main>
        <Footer data-id="element-16" data-mp="nxwv3et6z8sj" />
      </div>
    </>;
}
function initMetaPixel() {
  const pixelWindow = window as PixelWindow;
  try {
    if (!pixelWindow.fbq) {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue?.push(args);
        }
      }) as PixelFunction;
      pixelWindow.fbq = fbq;
      if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    pixelWindow.fbq?.('init', PIXEL_ID);
    pixelWindow.fbq?.('track', 'PageView');
  } catch (error) {
    console.warn('Meta Pixel init skipped:', error);
  }
}